<template>
  <div style="margin-top: 20px">
    <span style="font-size: 16px">{{$t('lang.firewall.addNAt')}}</span>
    <el-table :data="SNAT" border strip style="margin-top: 15px" >
      <el-table-column :label="`${$t('lang.ConfigSetting.Rule')}`">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.options.enabled">{{$t('lang.ConfigSetting.Enable')}}</el-checkbox>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.name')}`">
        <template slot-scope="scope">
          <el-input v-model="scope.row.options.name" size="mini" clearable></el-input>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.SRC')}`">
        <template slot-scope="scope">
          <el-select
            :placeholder="$t('lang.ConfigSetting.pleaseChoose')"
            v-model="scope.row.options.src"
            size="mini"
            class="Form-Input-Width">
            <el-option v-for="ele in SRCOptions" :key="ele.value" :label="ele.label" :value="ele.value"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.dest')}`">
        <template slot-scope="scope">
          <el-select
            :placeholder="$t('lang.ConfigSetting.pleaseChoose')"
            v-model="scope.row.options.dest"
            size="mini"
            class="Form-Input-Width">
            <el-option v-for="ele in SRCOptions" :key="ele.value" :label="ele.label" :value="ele.value"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.dest_ip')}`" min-width="110px">
        <template slot-scope="scope">
          <el-input ref="destIp" v-if="destIpInputShow" size="mini" v-model="scope.row.options.dest_ip" @blur="destIpBlur"></el-input>
          <el-select v-else size="mini" class="Form-Input-Width" v-model="scope.row.options.dest_ip" @change="(val) =>destIpChange(val, scope.$index)">
            <el-option v-for="(item, index) in IpList" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.SNAT')}`" min-width="110px">
        <template slot-scope="scope">
          <el-input ref="src" v-if="srcInputShow" size="mini" v-model="scope.row.options.src_dip" @blur="srcBlur"></el-input>
          <el-select v-else size="mini" class="Form-Input-Width" v-model="scope.row.options.src_dip" @change="(val) => srcChange(val, scope.$index)">
            <el-option v-for="(item, index) in IpList" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.operating')}`"> 
        <template slot-scope="scope">
           <el-button type="primary" size="small" @click="addRedirect(scope.row)">{{$t('lang.Button.Add')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import SelectInput from '../../SelectInput/index'

export default {
  components: {
    SelectInput,
  },
  props: ['IpList'],
  data() {
    return {
      SNAT: [
        {
          index: '',
          action: 1,
          sname: '',
          options: {
            enabled: false,
            name: '',
            proto: 'all',
            src: 'lan',
            src_ip: '',
            dest: 'wan',
            dest_ip: '',
            src_dip: '',
            target: 'SNAT'
          }
        }
      ],
      protoOptions: [
        { value: "TCP", label: this.$t("lang.ConfigSetting.TCP") },
        { value: "UDP", label: this.$t("lang.ConfigSetting.UDP") },
        { value: "tcp udp", label: this.$t("lang.ConfigSetting.TCP_UDP") },
        { value: "ICMP", label: this.$t("lang.ConfigSetting.ICMP") },
        { value: "all", label: 'All protocals' },
        { value: this.$t("lang.ConfigSetting.custom"), label: this.$t("lang.ConfigSetting.custom") },
      ],
      SRCOptions: [
        { value: "wan", label: "wan" },
        { value: "lan", label: "lan" },
        { value: "DROP", label: this.$t("lang.ConfigSetting.anyoneDest") }
      ],
      srcInputShow: false,
      destIpInputShow: false
    }
  },
  methods: {
    // 清空数据
    clearData() {
       this.SNAT = [
        {
          index: '',
          action: 1,
          sname: '',
          options: {
            enabled: false,
            name: '',
            proto: 'all',
            src: 'lan',
            src_ip: '',
            dest: 'wan',
            dest_ip: '',
            src_dip: '',
            target: 'SNAT'
          }
        }
      ]
    },
    // 获取下拉框返回的值并更新到通信规则相应的数据中。
    IpSelectInput(props,index){
      this.SNAT[index[0]].options[`${index[1]}`] = props
    },
    addRedirect(row) {
      this.$emit('addRedirect', this.SNAT[0])
      this.clearData()
    },
    // 监听选择下拉框的变化
    srcChange(val, index) {
      if(val === '自定义') {
        this.SNAT[index].options.src_dip = ''
        this.srcInputShow = true
        this.$nextTick(() =>{
          this.$refs.src.focus()
        })
      }
    },
    srcBlur(){
      this.srcInputShow = false
    },
    // 监听选择下拉框的变化
    destIpChange(val, index) {
      if(val === '自定义') {
        this.SNAT[index].options.dest_ip = ''
        this.destIpInputShow = true
        this.$nextTick(() =>{
          this.$refs.destIp.focus()
        })
      }
    },
    destIpBlur(){
      this.destIpInputShow = false
    }
  }
}
</script>